<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgement">
<h1>Acknowledgement</h1>
<p>I would like to acknowledge my husband, Gary, and my two children Becca and Dan for putting up with me in writing this book in our living space. It won’t be long now until we are in our dream home, in fact when this book is published, we will be firmly in place!</p>
<p>I would like to acknowledge my sister and my mum, who have always been a huge part of my life even at the worst of times and I am happy to say that my sister and I have a fantastic relationship these days.</p>
<p>To my good friend Naomi who was my saving grace at times, and my “Irish liqueur” drinking partner. Also, my best friend Louise who was at the other end of the country and I never told how bad things were because she had her own problems, but I have honoured her by using her name and picking out her “Scottishness” in Naomi’s character.</p>
<p>Finally:</p>
<p>To my dad, who taught me so much. You are remembered every single day with love.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?4c89d24d